export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'bet',
    label: 'field.bet',
    tdClass: 'text-right',
  },
  {
    key: 'result',
    label: 'field.result',
  },
]
